<template>
  <div class="main-container flex flex-center">
    <div class="main-box" style="overflow: hidden;width: calc(60% - 10px)">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="activeChange(1)"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="activeChange(2)"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="activeChange(3)"
            >{{ $t("m.options.listTab.star") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 4 }"
            @click="activeChange(4)"
            >{{ $t("m.options.listTab.machine") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
          type="primary"
          class="active-icon"
          :class="{ 'menu-active': status == 0 }"
          @click="getAll()"
        >
        {{ $t("m.index.chart.all") }}
        </el-button>
          <el-button
            type="primary"
            class="active-icon"
            :class="{ 'menu-active': status == 1 }"
            @click="getRecommend()"
          >
          {{ $t("m.index.chart.recommendChart") }}
          </el-button>
          <el-button
            type="primary"
            class="active-icon"
            :class="{ 'menu-active': status == 2 }"
            @click="getCollect()"
          >
          {{ $t("m.index.chart.collChart") }}
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
          <el-button type="primary"
          class="active-icon header-btn"
          @click="reset()"
          >
          <div style="display:flex;align-items: center;">
            <img src="@/assets/icons/reset.png" alt="" style="width: 18px;padding-right: 5px;">
            <span> {{ $t('m.common.reset') }}</span>
          </div>
          </el-button>
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px);">
        <el-row :gutter="20" class="box-content" type="flex">
          <el-col 
            :span="8"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="8"
                v-for="item in reportList"
              v-bind:key="item.id"
              style="padding: 8px;"
              @click.native="checkDevice(item)"
            >
            <div
              :class="[
            item.id == activeCurveId
              ? 'box-item box-half box-active'
              : 'box-item box-half',
          ]"
          style="flex-direction: column;"
          
          >
            <div class="box-nav-title">
              {{ item.name }}
            </div>
            <div class="flex" style="align-items: center">
              <div class="box-item-img">
                <img v-if="item.id == activeCurveId" :src="!!item.imgUrl ? item.imgUrl: 'http://oss.ihbcoffee.com/config/curveimgwhilte.png'" />
                <img v-else :src="!!item.imgUrl ? item.imgUrl: 'http://oss.ihbcoffee.com/config/curveimgblack.png'" />
                <div class="datetime">
                  <el-rate
                      :colors="['#FC9153', '#FC9153', '#FC9153']"
                      v-model="item.score"
                      disabled
                  ></el-rate>
                </div>
              </div>
              <div class="box-item-text">
                <!-- <div>
                <span class="text-title">{{ $t("m.chart.table.name") }}：</span
                ><span class="text-value">{{ item.name }}</span>
                </div> -->
                <div>
                <span class="text-title"
                >{{ $t("m.chart.table.duration") }}：</span
                ><span class="text-value">{{
                  timeFormatter(item.duration)
                  }}</span>
                </div>
                <div>
                <span class="text-title"
                >{{ $t("m.chart.table.machineName") }}：</span
                ><span class="text-value">{{
                    item.deviceName == null
                        ? "无"
                        : item.deviceName
                  }}</span>
                </div>
                <div>
                  <span class="text-title">{{ $t("m.chart.table.date") }}：</span
                  ><span class="text-value">{{
                      $moment(Number(item.createtime)).format("YYYY-MM-DD")
                    }}</span>
                </div>
                <div>
                  <span class="text-title">{{ $t("m.chart.table.username") }}：</span
                  ><span class="text-value">{{ item?.username || '--' }}</span>
                  </div>
              </div>
            </div>
           </div>
          </el-col>

        </el-row>
        <div class="table-footer">
          <el-pagination
              v-show="reportPage.total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="curvePageChange"
              :page-size="reportPage.pageSize"
              :total="reportPage.total"
          >
          </el-pagination>
        </div>
      </div>

    </div>
    <div class="main-box border-1px-all" id="pdfData" style="width: calc(40% - 10px)">
      <report-chart
        @finish="reportDetailLoadingFinish"
        :report-id="activeCurveId"
        :key="activeCurveId"
        :not-showuser="notShowuser"
        :url="fileUrl"
        @curve-deleted="handleCurveDeleted"
      ></report-chart>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center" style="margin-bottom:10px;gap: 20px">
          <el-select v-model="searchParamKey" style="width: 150px;" placeholder="">
            <el-option
                    v-for="item in searchParamsKeyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
            <div style="width: 100%">
              <el-input
                v-model="searchParamValue"
                :placeholder="$t('m.chart.table.placeholder3')"
              ></el-input>
            </div>
        </div>
        <div style="width: 100%">
          <el-select
            v-model="isSelectedUser"
            style="width: 100%"
            filterable
            remote
            reserve-keyword
            placeholder="请输入用户名并选择"
            :remote-method="getUserList"
            :loading="userLoading">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="getTable()" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import report from "@/components-online/curve/report";
var jsonFileStr = "";

export default {
  name: "curveList",
  components: {
    "report-chart": report,
  },
  data() {
    return {
      reportPage: {
        total: 0,
        pageSize: 50,
        pageNum: 1,
      },
      reportList: [],
      reportDetailDialog: false,
      reportKey: 0,
      selectReportId: 0,
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      url: "/manage/curve/union/list/ex",
      searchParamValue: "", //搜索框输入的值
      searchParamKey: "name",
      importShow: 0,
      loading: undefined,
      importReportDialog: false,
      addReportForm: {
        name: "",
        note: "",
      },
      importReportInfo: "",
      importFileJson: {},
      activeCurveId: 0,
      active1: 1,
      star: 2,
      dialogTableVisible: false,
      notShowuser: false,
      fileUrl: '',
      status: 0, // 0: 默认曲线列表 1:推荐曲线 2.收藏曲线
      typeMap: {
        1: 'time',
        2: 'name',
        3: 'level',
        4: 'count'
      },
      searchParamsKeyOptions: [
        {
          value: "name",
          label: "报告名称",
        },
        {
          value: "level",
          label: "报告等级",
        },
      ],
      userList: [],
      isSelectedUser: null,
      userLoading: false
    };
  },
  mounted() {
    //this.loadReportList()
    if (localStorage.role != 1) {
      this.notShowuser = true;
    }
    this.getTable();
  },
  watch: {
    $route(to) {
      if (to.path === "on-curveList") {
        this.getTable();
      }
    },
  },
  methods: {
    getTable() {
      let type = this.typeMap[this.active1];
      this.importShow = 0;
      const params = {
        pageNum: this.reportPage.pageNum,
        pageSize: this.reportPage.pageSize,
        sortField: type,
        share: this.status == 1 ? true : false,
        collect: this.status == 2 ? true : false
      }
      if (this.searchParamKey) {
          params[this.searchParamKey] = this.searchParamValue;
      }
      if (this.isSelectedUser) {
        params.userId = this.isSelectedUser;
      }
      if (this.$route.query.deviceId) {
        params.deviceId = this.$route.query.deviceId;
      }
      this.$http.post(this.url, params).then(resp => {
        this.reportList = resp.data.data.list;
        this.reportPage.total = resp.data.data.total;
        resp.data.data.list.length && (this.activeCurveId = resp.data.data.list[0].id);
        this.fileUrl = resp.data.data.list?.[0]?.fileUrl ?? `https://hb-coffee-image.oss-cn-hangzhou.aliyuncs.com/cf_data/${resp.data.data.list[0].userId}/${resp.data.data.list[0].note}` ?? null;

        if (this.dialogTableVisible) {
          this.dialogTableVisible = false;
        }
        this
      }).catch((err) => {
          console.info(err);
        });
    },
    searchByName() {
      this.getTable();
    },
    checkDevice(item) {
      console.log(item)
      this.activeCurveId = item.id;
      this.fileUrl = item.fileUrl ?? `https://hb-coffee-image.oss-cn-hangzhou.aliyuncs.com/cf_data/${item.userId}/${item.note}` ?? null; 
    },
    reportDetailLoadingFinish() {
    },
    curvePageChange(val) {
      this.reportPage.pageNum = val;
      this.getTable();
    },
    handleCurveDeleted(reportId) {
      this.getTable();
    },
    timeFormatter(value) {
      const minutes = Math.floor(value / 60);
      const secs = value % 60;
      const paddedMinutes = String(minutes).padStart(2, '0');
      const paddedSeconds = String(secs).padStart(2, '0');
      return `${paddedMinutes}:${paddedSeconds}`;
    },
    getRecommend() {
      this.status = 1;
      this.getTable();
    },
    getCollect() {
      this.status = 2;
      this.getTable();
    },
    activeChange(e) {
      this.active1 = e;
      this.getTable();
    },
    getAll() {
      this.status = 0;
      this.getTable();
    },
    getUserList(query) {
      if (query !== '') {
        this.userLoading = true;
        const params = { pageNum: 1, pageSize: 50, keyword: query };
        this.$http.post('/manage/user/list', params).then(res => {
          this.userList = res.data.data.list;
          this.userLoading = false;
        }).catch(e => {
          this.userLoading = false;
        })
      } else {
        this.userList = [];
      }
   
    },
    reset() {
      this.searchParamKey = 'name';
      this.isSelectedUser = null;
      this.searchParamValue = '';
      this.status = 0;
      this.$router.replace({ path: '/on-curveList' });
      this.getTable();
    }
  },
};
</script>
<style lang="scss" scoped>
.table-footer {
  position: sticky;
  bottom: 0;
  background: #1a1b1c29;
  padding-top: 10px;
}
.menu-active {
  border-color: #FC9153 !important;
  color: #FC9153 !important;
}
.header-btn {
  padding: 12px 15px;
  font-size: 14px;
  font-weight: bold;
}
.box-header-right {
  display: flex;
}
.box-item-img {
  width: 42%;
}
.box-item-img img {
  width: 100%;
}
.box-nav-title{
  width: 100%;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 5px;
  /* two-line clamp with ellipsis */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  /* allow breaking long words/numbers */
  overflow-wrap: anywhere;
}
.box-item.box-half {
  //width: calc(33% - 10px);
  //margin: 10px;
}
</style>
